import _ from 'lodash';
import axios from 'axios';
import moment from 'moment';
import QRcode from 'qrcode';
//import $ from 'jquery';
import * as Mutations from '../mutation-types';

const state = {
  scheduleToday: {},
  currentSchedule: null,
  comboMedSet: [],
};

const mutations = {
  [Mutations.RESET_SCHEDULE](state) {
    state.scheduleToday = {};
    state.currentSchedule = null;
    state.comboMedSet = [];
  },
  [Mutations.SET_TODAY_SCHEDULE](state, data) {
    data.forEach((d) => {
      state.scheduleToday[d.id] = d;
    });
  },
  [Mutations.SET_CURRENT_SCHEDULE_BY_ID](state, id) {
    state.currentSchedule = state.scheduleToday[id];
  },
  [Mutations.SET_CURRENT_SCHEDULE_DIRECTLY](state, data) {
    state.currentSchedule = data;
  },
  [Mutations.SET_SCHEDULE_MED_LIST](state, data) {
    state.scheduleMedList = data;
  },
};

const actions = {
  getSchedule({ commit, rootState }, date) {
    return rootState.instance.get('/api/schedule/', {
      params: {
        date,
        hidden: false,
        bed__ward__area: rootState.device.systemArea.id,
      },
    })
    .then((res) => {
      // res.data.sort((a, b) => {
      //   const date1 = new Date(a.time);
      //   const date2 = new Date(b.time);
      //   return date1 - date2;
      // });

      res.data.results.forEach((item) => {
        // item.selected = false;
        if (item.fetch_event.length > 0) {
          item.fetched = true;
        } else {
          item.fetched = false;
        }
      });
      commit('SET_TODAY_SCHEDULE', res.data.results);
    });
  },
  //20190516 add by aaron
  getOperatingRoomSchedule({ commit, rootState }) {
    return rootState.instance.get('/api/operating-room-schedule/', {
      params: {
        hidden: false,
      },
    })
    .then((res) => {
      commit('SET_TODAY_SCHEDULE', res.data.results);
    });
  },
  getTodaySchedule({ commit, dispatch, rootState }) {
    return dispatch('getSchedule', moment().format('YYYY-MM-DD'));
  },
  getYesterdaySchedule({ commit, dispatch, rootState }) {
    return dispatch('getSchedule', moment().subtract(1, 'days').format('YYYY-MM-DD'));
  },
  getComboMedSet({ state, getters, rootState }) {
    return rootState.instance.get('/api/combo-medication-set/', {
      params: {
        parent_medication: state.currentSchedule.medication.id,
      },
    })
      .then((res) => {
        res.data.forEach((item) => {
          item.selected = false;
          item.fetched = false;
          item.drugInDevice = _.filter(getters.drugInDeviceList, (drugStorage) => {
            return drugStorage.medication.id === item.child_medication.id && drugStorage.stock > 0;
          });
          item.amountInSystem = 0;
          item.drugInDevice.forEach((d) => {
            item.amountInSystem += d.stock;
          });
        });
        state.comboMedSet = res.data;
      });
  },
  selectComboMed({ state, commit, dispatch }, payload) {
    state.comboMedSet.forEach((item) => {
      if (item.child_medication.id === payload.med.id) {
        item.selected = payload.select;
      }
    });
    dispatch('setDrugListForFetch', payload);
  },
  startSchedulMed({ state, commit }) {
    const drugStorageList = [];
    commit('SET_SCHEDULE_MED_LIST', _.sortBy(Object.values(state.selectedMed), ['drugStorage.device.net.id', 'drugStorage.device.net.row_id', 'drugStorage.device.pos_row', 'drugStorage.device.relative_col']));
    state.scheduleMedList.forEach((med) => {
      drugStorageList.push(_.sortBy(med.drugStorage, [(o) => { return moment(o.expired_date); }])[0]);
    });
    commit('SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY', drugStorageList);
    console.log(drugStorageList);
  },
  setCurrentScheduleById({ state, commit, rootState }, id) {
    return rootState.instance.get(`/api/schedule/${id}`)
      .then((res) => {
        state.currentSchedule = res.data;
      })
      .catch((err) => {
        commit('SET_MESSAGE', {
          type: 'error',
          context: '找不到此排程',
        });
      });
  },
  printQR({ state, rootState, getters }, fetchItem) {
    // printer setting for TM-T82II, MediaSize: 56mm*60mm, PaperReducion: Top margin
    const QRCanvas = document.createElement('canvas');
    QRcode.toCanvas(QRCanvas, `***THC-schedule: ${state.currentSchedule.id}***`, (error) => {
      if (error) console.error(error);
      console.log('success');
    });
    const CGMHQRCanvas = document.createElement('canvas');
    QRcode.toCanvas(CGMHQRCanvas, `${state.currentSchedule.seq_number}`, (error) => {
      if (error) console.error(error);
      console.log('success');
    });
    const printWindow = window.open('', 'PRINT', 'height=300,width=400');
    const divMain = document.createElement('div');
    const divLeft = document.createElement('div');
    const divRight = document.createElement('div');
    const divQRwrapper = document.createElement('div');
    const divCGMHQRwrapper = document.createElement('div');
    const schedule = document.createElement('p');
    const scheduleBirthday = document.createElement('p');
    const medRecordNum = document.createElement('p');
    const scheduleTime = document.createElement('p');
    const bed = document.createElement('p');
    const medSet = document.createElement('p');
    const logo = document.createElement('img');
    // style setting
    schedule.style = 'margin: 0';
    scheduleBirthday.style = 'margin: 0';
    medRecordNum.style = 'margin: 0';
    scheduleTime.style = 'margin: 0';
    medSet.style = 'margin: 0';
    bed.style = 'margin: 0';
    // logo.src = '../../assets/img/autoIX_logo.png';
    // logo.width = 180;
    QRCanvas.style.width = '80px';
    QRCanvas.style.height = '80px';
    CGMHQRCanvas.style.width = '80px';
    CGMHQRCanvas.style.height = '80px';
    // console.log(logo);

    if (state.currentSchedule.patient.name) schedule.innerText = state.currentSchedule.patient.name;
    if (state.currentSchedule.patient.birthday) scheduleBirthday.innerText = moment(state.currentSchedule.patient.birthday).format('YYYY/MM/DD');
    //if (state.currentSchedule.bed) bed.innerText = `床號：${state.currentSchedule.bed.ward.name}${state.currentSchedule.bed.code}`;
    //20190516 modified
    if (state.currentSchedule.bed){
      if (state.currentSchedule.bed.ward){
        bed.innerText = `床號：${state.currentSchedule.bed.ward.name}${state.currentSchedule.bed.code}`;
      }
      else{
        bed.innerText = `床號：${state.currentSchedule.bed.code}`;
      }
    } 
    medRecordNum.innerHTML = state.currentSchedule.patient.med_record_number;
    const t = new Date(state.currentSchedule.time);
    console.log(t);
    console.log(moment(t).format('YYYYMMDD'));
    console.log(moment(t).format('HHmm'));
    scheduleTime.innerHTML = new Date(t).toLocaleDateString();
    if (state.currentSchedule.medication) medSet.innerHTML = state.currentSchedule.medication.generic_name;
    // printWindow.document.write(`<p>${this.currentSchedule.patient.med_record_number}</p>`);
    printWindow.document.body.appendChild(divMain);
    divMain.appendChild(divLeft);
    divMain.appendChild(divRight);

    if (state.currentSchedule.seq_number !== null) {
      const canvasTitle = document.createElement('p');
      canvasTitle.innerText = '工作車條碼';
      canvasTitle.style = 'margin: 0px';
      divQRwrapper.appendChild(canvasTitle);
      divQRwrapper.appendChild(CGMHQRCanvas);
    }

    const ADCcanvasTitle = document.createElement('p');
    ADCcanvasTitle.innerText = '藥櫃條碼';
    ADCcanvasTitle.style = 'margin: 0px';
    divCGMHQRwrapper.appendChild(ADCcanvasTitle);
    divCGMHQRwrapper.appendChild(QRCanvas);

    divRight.appendChild(divQRwrapper);
    divRight.appendChild(divCGMHQRwrapper);
    // divLeft.appendChild(logo);
    divLeft.appendChild(schedule);
    divLeft.appendChild(scheduleBirthday);
    divLeft.appendChild(medRecordNum);
    divLeft.appendChild(medSet);
    divLeft.appendChild(bed);
    divLeft.appendChild(scheduleTime);
    // printWindow.document.body.appendChild(document.createElement('hr'));

    for (let i = 0; i < fetchItem.length; i += 1) {
      const drugForFetch = fetchItem[i];
      const item = document.createElement('div');
      const itemInfo = document.createElement('div');
      itemInfo.innerText = `${drugForFetch.med.generic_name} - ${drugForFetch.dose} ${drugForFetch.doseUnit}`;
      item.appendChild(itemInfo);
      item.style = 'font-size: 12px;width: 100%; text-align: left';
      itemInfo.style = 'padding-left: 1rem';
      printWindow.document.body.appendChild(item);
    }

    printWindow.document.body.style = 'text-align: center; display: flex; flex-direction: column; align-items: center;';
    divMain.style = 'display: flex';
    divLeft.style = 'text-align: center; display: flex; flex-direction: column; justify-content: center; align-items: center;';
    divRight.style = 'text-align: center; display: flex; flex-direction: row; justify-content: center; align-items: center;';
    // printWindow.document.write()

    printWindow.print();
    printWindow.close();
  },
  //returnFetchDataToCGMHHIS({ state, rootState, getters }, payload) {
  //20190409 modified by aaron
  returnFetchDataToCGMHHIS({ state, rootState, getters, dispatch }, payload) {
    // payload: { medication: PKA027P, qty: 1, rx_user: A12345678 }
    console.log('returnFetchDataToCGMHHIS', payload);
    const datetimeNow = moment().format('YYYYMMDD/HHmm');
    const data = {
      CHTNO: state.currentSchedule.patient.med_record_number,
      ODERNO: state.currentSchedule.seq_number,
      DRUG_CODE: payload.medication,
      //20190503 modified
      //DEPOSIT_DATE: datetimeNow.split('/')[0],
      //DEPOSIT_TIME: datetimeNow.split('/')[1],
      DEPOSIT_DATE: moment(state.currentSchedule.time).format('YYYYMMDD'),
      DEPOSIT_TIME: moment(state.currentSchedule.time).format('HHmm'), 
      ////////////////////////////////////////////////////////////////////
      TAKE_DOSE: payload.dose,
      TAKE_QTY: payload.qty,
      TAKE_NRSIDNO1: rootState.user.user.username,
      TAKE_NRSIDNO2: payload.rx_user,
    };
    console.log(data);
    
    // return retrieve info
    const CGMHHISUrl = 'http://lnkapp.cgmh.org.tw/cghcns/ADCDrug.asmx/Set_ADC_TAKE_DATA';
    //for test
    //const CGMHHISUrl = 'http://httpbin.org/xml';
    //const CGMHHISUrl = 'http://httpbin.org/robots.txt';
    //const CGMHHISUrl = 'http://httpbin.org/ip';

    const urlSearchData = new URLSearchParams();
    //20190517 modified by aaron
    //urlSearchData.set('p_costid', '348H0');
    console.log('p_costid:',state.currentSchedule.p_costid);
    urlSearchData.set('p_costid', state.currentSchedule.p_costid);
    urlSearchData.set('p_args', JSON.stringify([data]));
    fetch(CGMHHISUrl, {
      body: urlSearchData,
      mode: 'no-cors',
      method: 'POST',
      //for test
      //method: 'GET',
    })
    //20190409 modified by aaron
    .then((res) => {
      //return res.json();
      return res.text();
    })
    .then((json) => {
      console.log(json);
      // for test
      //var parser = new DOMParser();
      //var xmlDoc = parser.parseFromString(json,"text/xml");
      //console.log(xmlDoc);
      //console.log(xmlDoc.getElementsByTagName("title")[0].childNodes[0].nodeValue)
      //console.log(json.substring(0,10));
      //
      //console.log(JSON.parse(json));
      //if(json.origin) {
      //if(json.isSucess === "Y") {
        console.log('send to HIS successfully');
        dispatch('recordAction', { eventType: 'HIS_NURSING_SUCCESS' });
      //}
      //else {
      //  console.log('send to HIS failed');
      //  dispatch('recordAction', { eventType: 'HIS_NURSING_FAIL' });
      //}  
    })
    .catch((err) => {
      console.log(err);
      console.log('send to HIS error');
      dispatch('recordAction', { eventType: 'HIS_NURSING_ERR' });
    });
    /*
    .then((res) => {
      //console.log(res.json());
      console.log(res);
      console.log('send to HIS successfully');
    })
    .catch((err) => {
      console.log(err);
      console.log('send to HIS failed');
    });
    */
  },
};

const getters = {
  scheduleToday: (state) => {
    return state.scheduleToday;
  },
  comboMedSet: (state) => {
    return state.comboMedSet;
  },
  currentSchedule: (state) => {
    return state.currentSchedule;
  },
  currentScheduleMed: (state) => {
    return state.currentScheduleMed;
  },
  nextScheduleMed: (state) => {
    return state.nextScheduleMed;
  },
};

const store = {
  state,
  mutations,
  actions,
  getters,
};

export default store;



// WEBPACK FOOTER //
// ./src/vuex/module/schedule.js